import { Box, Col, Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Combobox } from '@opendoor/atoms/combobox';
import { Text } from '@opendoor/atoms/text';

import { CityNearMeButton } from './NearMeButton';

interface DirectoryHeaderProps {
  pageType: 'city' | 'state';
  locationName: string;
  locationSlug: string;
  totalCount: number;
  stateName?: string | null;
  displayingCity?: string | null;
  availableCities?: Array<{ name: string; slug: string }> | null;
  nearMeCity?: string | null;
  nearMeCityCount?: number | null;
  marketSlug?: string;
}

export const DirectoryHeader: React.FC<DirectoryHeaderProps> = ({
  pageType,
  locationName,
  locationSlug,
  totalCount,
  stateName,
  displayingCity,
  availableCities,
  nearMeCity,
  nearMeCityCount,
  marketSlug,
}) => {
  const hasMultipleCities = availableCities && availableCities.length > 1;

  const cityOptions =
    availableCities?.map((city) => ({ label: city.name, value: city.slug })) ?? [];

  const StateHeader = () => (
    <>
      <Text as="h1" className="text-header-lg pb-1 text-center">
        Homes for Sale in {locationName}
      </Text>

      {displayingCity && (
        <Text as="h2" className="text-header-sm pb-2 text-center">
          Top properties in {displayingCity}
        </Text>
      )}
    </>
  );

  const CityHeader = () => (
    <Text as="h1" className="text-header-lg pb-2 text-center">
      {totalCount} {totalCount === 1 ? 'Home' : 'Homes'} for Sale in {locationName}
      {stateName && `, ${stateName}`}
    </Text>
  );

  return (
    <Col className="sticky top-0 z-[1] bg-od-bg-primary pb-2">
      {pageType === 'state' ? <StateHeader /> : <CityHeader />}
      <Row
        className={`items-center justify-center gap-2 lg:gap-4 ${
          hasMultipleCities ? 'flex-col md:flex-row' : 'flex-row'
        }`}
      >
        <CityNearMeButton city={nearMeCity} count={nearMeCityCount} />
        {hasMultipleCities && (
          <Box className="min-w-38">
            <Combobox
              aria-label="Top homes in"
              options={cityOptions}
              value={cityOptions.find((option) => option.value === marketSlug) ?? null}
              onValueChange={(option) => {
                if (option) {
                  window.location.href = `/homes/state/${locationSlug}?city=${option.value}`;
                }
              }}
              placeholder="Top homes in"
            />
          </Box>
        )}
        <Button
          analyticsName="see-map-link"
          href={`/homes/${marketSlug}`}
          variant="primary"
          aria-label="View Map"
        >
          View Map
        </Button>
      </Row>
    </Col>
  );
};
